import { render, staticRenderFns } from "./CoachesSalary.vue?vue&type=template&id=68da2e1b"
import script from "./CoachesSalary.vue?vue&type=script&lang=js"
export * from "./CoachesSalary.vue?vue&type=script&lang=js"
import style0 from "./CoachesSalary.vue?vue&type=style&index=0&id=68da2e1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports